module.exports = __webpack_public_path__ + "static/media/sponsors.47a98c67.svg";